import React, { useEffect, useState } from "react";

import { StyleSheet, View, Text, Platform } from "react-native";

import moment from "moment";
import { hasItems } from "../../../../helpers/utils";
import ManaHourMinutes from "../../common/ManaHourMinutes";
import AppTheme from "../../AppTheme";

const DATE_FORMAT = "YYYY-MM-DD";

export default function ReflectionCards({
  reflection,
  reflectionHours,
  lifeTimeAverage,
}) {
  const [progress, setProgress] = useState(0);
  const [previous, setPrevious] = useState(0);
  const [average, setAverage] = useState(0);

  useEffect(() => {
    const { timeline } = reflection || {};
    if (!timeline) return;

    const selectedDay = moment(reflection.edit_day).format(DATE_FORMAT);
    const dayIndex = (reflectionHours[selectedDay] || {}).index;

    if (hasItems(timeline.hours)) {
      // Progress
      let prev = 0;
      let current = 0;
      if (dayIndex >= 0) {
        current = timeline.hours[dayIndex];
        if (dayIndex > 0 && timeline.hours[dayIndex - 1]) {
          prev = timeline.hours[dayIndex - 1];
        }
      }

      setPrevious(prev);
      if (prev > 0) {
        setProgress(Math.round((100 * (current - prev)) / prev));
      }

      // Average
      setAverage(lifeTimeAverage);
    } else {
      setProgress(0);
      setAverage(0);
    }
  }, [reflection]);

  return (
    <View style={styles.container}>
      <View style={styles.card}>
        <Text style={styles.cardLabel}>Previous</Text>
        <ManaHourMinutes duration={previous} />
      </View>

      <View style={styles.card}>
        <Text style={styles.cardLabel}>Change</Text>
        <View style={{ flexDirection: "row" }}>
          <Text style={styles.progressText}>
            {progress > 0 ? "+" : ""}
            {progress}
          </Text>
          <Text style={styles.percent}>%</Text>
        </View>
      </View>

      <View style={styles.card}>
        <Text style={styles.cardLabel}>Average</Text>
        <ManaHourMinutes duration={average} />
      </View>

      {/* {goal ? (
        <View style={styles.card}>
          <ManaHourMinutes duration={goal_target_hours} />
          <Text style={styles.cardLabel}>{summaryText}</Text>
        </View>
      ) : null} */}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    marginTop: 14,
  },
  card: {
    backgroundColor: "#F3F2F1",
    borderRadius: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 6,
    width: 80,
    height: 46,
  },
  cardLabel: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#8B92A1",
  },
  progressText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  percent: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    paddingTop: 4,
  },
});
